import { RouteObject } from 'react-router-dom'
import { AuthCallbackScreen } from './auth-callback-screen'
import { PrivacyPolicyScreen } from './legal/privacy-policy-screen'
import { TermsAndConditionsScreen } from './legal/terms-and-conditions-screen'
import { LogoutScreen } from './logut-screen'
import { GetInScreen } from './public/get-in-screen'
import { FeaturedWorkoutPlayerScreen } from './public/featured-workout-player-screen'

export const authRoutes: RouteObject[] = [
  { path: '/auth/get-in/*', element: <GetInScreen /> },
  // Playback for a signed-out visitor. It lives under /auth/* on purpose: that prefix is what
  // `app/index.tsx` branches on to render AuthLayout, which has no MainNav, no SessionContext
  // and no authed data loading — exactly the conditions a guest is in.
  { path: '/auth/featured/:workoutId', element: <FeaturedWorkoutPlayerScreen /> },
  { path: '/auth/callback', element: <AuthCallbackScreen /> },
  { path: '/auth/legal/terms-and-conditions', element: <TermsAndConditionsScreen /> },
  { path: '/auth/legal/privacy-policy', element: <PrivacyPolicyScreen /> },
  { path: '/auth/logout', element: <LogoutScreen /> },
]
